// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2udHN","footer":"ModalInfo_footer__3vWjt"};